import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getQuoteSubscriptionApi } from 'api';
import { Box, Typography } from '@material-ui/core';
import { BackdropCircular } from 'components';


const SubscriptionInfo = ({id}) => {
  const dispatch = useDispatch();
  const { loadingCustomerSubscription, customerSubscription } = useSelector((state: IReduxState) => state.quote);

  useEffect(() => {
    if (!customerSubscription.length) {
      getQuoteSubscriptionApi({dispatch,
        sortField: 'created_at',
        pageSize: 3,
        currentPage: 1,
        filterConditions: [
          {
            field: 'customer_id',
            value: id,
            conditionType: 'eq'
          },
          {
            field: 'status',
            value: 'canceled',
            conditionType: 'neq'
          },
        ]});
    }
  }, [id]);

  const renderSubscriptions = () => {
    if (customerSubscription.length > 0) {
      return customerSubscription.map((sub) => (
        <div key={sub.id} className="flex-column items-end">
          <Typography align="right" variant="h6" className="text-12">
            {sub.description}
          </Typography>
          <Typography align="right" className="text-muted text-12">
            {sub.frequency_count !== 0
              ? `Every${sub.frequency_count === 1 ? '' : ` ${sub.frequency_count}`} ${sub.frequency_unit}${
                sub.frequency_count > 1 ? 's' : ''
              }`
              : 'One Time Purchase'}
          </Typography>
        </div>
      ));
    }

    return <Typography className="text-muted text-12">No subscriptions found.</Typography>;
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" my={1}>
        <Typography className="text-muted text-12">Subscription</Typography>
        <Box display="flex" flexDirection="column" justifyContent="space-between" alignItems="flex-end" >
          {renderSubscriptions()}
        </Box>

      </Box>
      <BackdropCircular loading={loadingCustomerSubscription} />
    </>
  );
};

export default SubscriptionInfo;
